import { z } from 'zod'

const transactionItemSchema = z.object({
  name: z.string().min(1),
  amount: z.number(),
  category_id: z.string().nullable().optional(),
})

export const createTransactionSchema = z.object({
  paid_by: z.string().min(1, { message: '支払者を選択してください' }),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, { message: '日付が無効です' }),
  store_name: z.string().optional(),
  memo: z.string().optional(),
  total_amount: z.number(),
  tax_amount: z.number().min(0).optional(),
  input_method: z.string(),
  items: z
    .array(transactionItemSchema)
    .min(1, { message: '品目を1つ以上入力してください' }),
  scope: z.enum(['household', 'personal']),
  tag_ids: z.array(z.string()).optional(),
})

export const updateTransactionSchema = z.object({
  paid_by: z.string().min(1, { message: '支払者を選択してください' }),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, { message: '日付が無効です' }),
  store_name: z.string().optional(),
  memo: z.string().nullable().optional(),
  total_amount: z.number(),
  tax_amount: z.number().min(0).optional(),
  items: z
    .array(transactionItemSchema)
    .min(1, { message: '品目を1つ以上入力してください' }),
  scope: z.enum(['household', 'personal']),
  tag_ids: z.array(z.string()).optional(),
})

export type CreateTransactionInput = z.infer<typeof createTransactionSchema>
export type UpdateTransactionInput = z.infer<typeof updateTransactionSchema>
